import { createFileRoute } from '@tanstack/react-router';

import { ExpensesViewPage } from '@/areas/manufacturing-templates/Expenses/ExpensesView/ExpensesViewPage';
import { canViewManufacturing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/manufacturing/_sidebar/expenses/')({
    staticData: { access: { permissions: canViewManufacturing }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ExpensesViewPage />;
}
